import { COMPENSATION_DISCLOSURE, SCOPE_DISCLOSURE } from "@/lib/disclosureTexts";

/**
 * "How we are paid" / "What we show" (Design Specification Sections 7, 8.5, 9.4, 10.4; compliance/
 * 01_texas_disclosures.md Section 3). Same wording already shipped on pages/HowItWorks.jsx, centralized here
 * so Plans, Plan Detail, Texas Landing, and Enroll render the identical, already-reviewed text instead of a
 * second draft.
 */
export default function CompensationDisclosure({ showScope = true, className = "", testId = "compensation-disclosure" }) {
  return (
    <div className={`text-sm text-[#475569] space-y-2 ${className}`} data-testid={testId}>
      <p data-text-version={COMPENSATION_DISCLOSURE.id} data-text-status={COMPENSATION_DISCLOSURE.status}>
        <strong className="text-[#0A2540]">{COMPENSATION_DISCLOSURE.heading}.</strong> {COMPENSATION_DISCLOSURE.text}
      </p>
      {showScope && (
        <p data-text-version={SCOPE_DISCLOSURE.id} data-text-status={SCOPE_DISCLOSURE.status}>
          <strong className="text-[#0A2540]">{SCOPE_DISCLOSURE.heading}.</strong> {SCOPE_DISCLOSURE.text}
        </p>
      )}
    </div>
  );
}
